import {isNotNil} from 'ramda-adjunct';

import {getSafely} from 'shared/web';

import type {TransformedDefinitionApiResponse} from '../../../types/Api';
import type {FindColumnEntry} from '../components/FindColumn/FindColumnDropdown';

type FindColumnDefinition = Pick<TransformedDefinitionApiResponse, 'columns' | 'groups'>;

/**
 * Entries for the toolbar Find column dropdown: every column that is not
 * definition-hidden, with its group's display title resolved from
 * `definition.groups`, so the dropdown can match and show the group a column
 * belongs to (T20-142344 — find a platform's columns by the platform name).
 */
export const buildFindColumnEntries = (definition: FindColumnDefinition): FindColumnEntry[] =>
  definition.columns
    .filter((column) => !column.hidden)
    .map((column) => ({
      key: column.key,
      headerName: column.title,
      groupLabel: isNotNil(column.group)
        ? getSafely(definition.groups, column.group)?.headerName
        : undefined,
    }));
